import script from "./Tabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tabs.vue?vue&type=script&lang=ts&setup=true"

import "./Tabs.vue?vue&type=style&index=0&id=030424ae&lang=scss&scoped=true"
import "./Tabs.vue?vue&type=style&index=1&id=030424ae&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-030424ae"]])

export default __exports__